import React, { CSSProperties, useState } from 'react'
import { List, Modal, Row, Typography } from 'antd'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Request, RequestStandardBilling } from 'src/types'
import { ButtonTitled, Empty } from 'src/components/Ant'
import { saveRequestStandardAssignments } from 'src/core/store/ducks/requests/actions'

import { Card } from './styles'
import ModalForm from '../ModalForm'

interface Props {
  bodyStyle?: CSSProperties
  enableModal?: boolean
  handleDelete?(item: RequestStandardBilling): void
  handleEdit?(item: RequestStandardBilling): void
  request: Request
}

function BillingSummary({
  bodyStyle = {},
  enableModal = false,
  handleDelete,
  handleEdit,
  request
}: Props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  /* billing_reference_type
  interface OptionBillingReferenceTypeList { label: string; value: BillingReferenceType }
  const billingReferenceTypeList = useMemo<OptionBillingReferenceTypeList[]>(
  () => [{ label: 'Contract', value: 'CONTRACT' },{ label: 'Cost center', value: 'COST_CENTER' }],[])
  */

  const [visibleModal, setVisibleModal] = useState<boolean>(false)
  const [itemEdit, setItemEdit] = useState<RequestStandardBilling>()

  function openEditModal(item: RequestStandardBilling) {
    setVisibleModal(true)
    setItemEdit(item)
  }

  function confirmDelete(item: RequestStandardBilling) {
    Modal.confirm({
      cancelText: t('common.actions.cancel'),
      content: t('common.actions.delete.message', {
        number: `#${item.request_standard_billing_number}`
      }),
      onCancel() {},
      onOk: async () => {
        return new Promise(() => {
          dispatch(
            saveRequestStandardAssignments({
              request_standard_billings: [{ ...item, active: false }]
            })
          )
        })
      },
      title: t('common.actions.delete.title')
    })
  }

  const blockNewBilling =
    request.request_standard_assignments.request_standard_billings.length > 0
  return (
    <>
      {enableModal && (
        <ModalForm
          itemEdit={itemEdit}
          toggle={() => {
            setVisibleModal(false)
            setItemEdit(null)
          }}
          visible={visibleModal}
        />
      )}
      <Card
        data-test-id="summary-billings"
        bodyStyle={bodyStyle}
        extra={[
          ...(!!enableModal &&
          request.request_standard_assignments.request_standard_sharings.filter(
            countItem => countItem.active
          ).length
            ? [
                <ButtonTitled
                  key="add-itinerary"
                  icon="plus"
                  onClick={() => setVisibleModal(true)}
                  size="default"
                  disabled={blockNewBilling}
                  tooltip="common.actions.add"
                />
              ]
            : [])
        ]}
        title="web.assignment.billing.list-title"
      >
        <List
          data-test-id="billing-list"
          dataSource={request.request_standard_assignments.request_standard_billings.filter(
            ({ active }: RequestStandardBilling) => active
          )}
          itemLayout="horizontal"
          locale={{ emptyText: <Empty onlyText /> }}
          renderItem={(item: RequestStandardBilling, index: number) => (
            <List.Item
              actions={[
                ...(!!handleEdit || enableModal
                  ? [
                      <ButtonTitled
                        icon="edit"
                        onClick={
                          enableModal
                            ? () => openEditModal(item)
                            : () => handleEdit(item)
                        }
                        shape="circle"
                        tooltip="common.actions.edit"
                      />
                    ]
                  : []),
                ...(!!handleDelete || enableModal
                  ? [
                      <ButtonTitled
                        icon="delete"
                        onClick={
                          enableModal
                            ? () => confirmDelete(item)
                            : () => handleDelete(item)
                        }
                        shape="circle"
                        tooltip="common.actions.remove"
                        type="danger"
                      />
                    ]
                  : [])
              ]}
              data-test-id={`billing-item-${index}`}
            >
              <List.Item.Meta
                title={
                  item.request_standard_billing_id
                    ? `#${item.request_standard_billing_number}`
                    : undefined
                }
                description={
                  <>
                    {/* refBillingReferenceTypeSelect
                    <Row>
                      <Typography.Text strong>{`${t(
                        'web.assignment.billing.form.reference.title'
                      )}: `}</Typography.Text>
                      {
                        billingReferenceTypeList.find(
                          billingReferenceTypeItem =>
                            billingReferenceTypeItem.value ===
                            item.billing_reference_type
                        ).label
                      }
                    </Row> */}
                    <Row>
                      <Typography.Text strong>
                        {`${t(
                          'web.assignment.billing.form.billing-type.title'
                        )}: `}
                      </Typography.Text>
                      {!item.billing_type.code
                        ? ''
                        : `${item.billing_type.code} - `}
                      {item.billing_type.name}
                    </Row>
                    <Row>
                      <Typography.Text strong>
                        {`${t('web.assignment.billing.form.target.title')}: `}
                      </Typography.Text>
                      {!item.target.code ? '' : `${item.target.code} - `}
                      {item.target.name}
                    </Row>
                    {!!item.observation && (
                      <Row>
                        <Typography.Text strong>
                          {`${t(
                            'web.assignment.billing.form.observation.title'
                          )}: `}
                        </Typography.Text>
                        {item.observation}
                      </Row>
                    )}
                  </>
                }
              />
            </List.Item>
          )}
        />
      </Card>
    </>
  )
}

export default BillingSummary
